import * as moment from 'moment-timezone';
import { environment } from '../../environments/environment';

export class DateFieldHelper {

    public initDateField(rootElement, resultValueObj, inputField?) {
        $('.date', rootElement).daterangepicker({
            singleDatePicker: true,
            showDropdowns: true,
            timePicker: false,
            locale: {
                format: 'DD.MM.YYYY'
            },
            autoUpdateInput: false
        }).on('change', function(e) {
            if ($(this).val()) {
                $(this).trigger('apply.daterangepicker');
            } else {
                resultValueObj['value'] = '';
                if (inputField) {
                    inputField.value = '';
                }
            }
        });

        $('.date', rootElement).on('apply.daterangepicker', function(ev, picker) {
            $(this).val($(this).data('daterangepicker').startDate.format('DD.MM.YYYY'));
            resultValueObj['value'] = moment($(this).val(), 'DD.MM.YYYY').format('YYYY-MM-DD');
            if (inputField) {
                inputField.value = $(this).val();
            }
        });
    }

    public initDatetimeField(rootElement, resultValueObj, inputField?) {
        $('.datetime', rootElement).daterangepicker({
            singleDatePicker: true,
            timePicker: true,
            showDropdowns: true,
            timePicker24Hour: true,
            locale: {
                applyLabel: 'Применить',
                cancelLabel: 'Отменить',
                format: 'DD.MM.YYYY HH:mm:ss [(MSK' + environment.timezoneUserOffsetMsk + ')]'
            },
            autoUpdateInput: false,
        }).on('change', function(e) {
            if ($(this).val()) {
                $(this).trigger('apply.daterangepicker');
            } else {
                $(this).trigger('cancel.daterangepicker');
            }
        });

        $('.datetime', rootElement).on('apply.daterangepicker', function(ev, picker) {
            $(this).val($(this).data('daterangepicker').startDate.format('DD.MM.YYYY HH:mm:ss') + ' (MSK' + environment.timezoneUserOffsetMsk + ')');
            resultValueObj['value'] = moment($(this).val(), 'DD.MM.YYYY HH:mm').format('YYYY-MM-DD HH:mm:ss') + environment.timezoneUser;

            if (inputField) {
                inputField.value = $(this).val();
            }
        });

        $('.datetime', rootElement).on('cancel.daterangepicker', function(ev, picker) {
            $(this).val('');
            resultValueObj['value'] = '';
            if (inputField) {
                inputField.value = '';
            }
        });
    }

    public transformDateValue(value) {
        if (value) {
            return moment(value, 'YYYY-MM-DD').format('DD.MM.YYYY');
        }
        return '';
    }

    public transformDatetimeValue(value) {
        if (value) {
          return moment(value + environment.timezoneDefault, 'YYYY-MM-DD HH:mm:ssZ').utcOffset(environment.timezoneUser).format('DD.MM.YYYY HH:mm:ss '+'[(MSK' + environment.timezoneUserOffsetMsk + ')]');
        }
        return '';
    }

}



// WEBPACK FOOTER //
// ./src/app/document/date-field-helper.ts